export interface JsonPathField {
  path: string;
  value: unknown;
  type: string;
}

export const extractJsonPaths = (obj: Record<string, unknown>, prefix = ''): JsonPathField[] => {
  let paths: JsonPathField[] = [];

  for (const [key, value] of Object.entries(obj)) {
    const currentPath = prefix ? `${prefix}.${key}` : key;

    if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
      paths = paths.concat(extractJsonPaths(value as Record<string, unknown>, currentPath));
    } else {
      paths.push({
        path: currentPath,
        value: value,
        type: typeof value,
      });
    }
  }

  return paths;
};

export const getValueFromPath = (obj: Record<string, unknown>, path: string): unknown => {
  return path.split('.').reduce((acc: unknown, part: string) => {
    if (acc && typeof acc === 'object' && !Array.isArray(acc)) {
      return (acc as Record<string, unknown>)[part];
    }
    return undefined;
  }, obj);
};
